var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-info" }, [
    _c("div", { staticClass: "iframe-header" }, [
      _c("div", { staticClass: "iframe-info" }, [
        _c("iframe", {
          staticStyle: { border: "none" },
          attrs: {
            src: _vm.iframeURL,
            width: "100%",
            height: "100%",
            title: "Contract Details",
            id: "contractFrame",
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }